import {
  AdminHeader,
  Div,
  Tab,
  handleSetUrlSearchParams,
  isAdmin,
} from '@vgrubs/components';
import { BrandSettings } from './sections/BrandSettings';
import { GeneralSettings } from './sections/GeneralSettings';
import { LocationSettings } from './sections/LocationSettings';
import { useSearchParams } from 'react-router-dom';
enum Tabs {
  General = 'general',
  Location = 'location',
  Brand = 'brand',
}

export const Settings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || Tabs.General;

  const setTab = (tab: Tabs) => {
    handleSetUrlSearchParams('tab', tab, setSearchParams);
  };

  const actions = [
    {
      value: Tabs.General,
      label: 'General',
      onClick: () => setTab(Tabs.General),
    },
    {
      value: Tabs.Location,
      label: 'Location',
      onClick: () => setTab(Tabs.Location),
    },

    {
      value: Tabs.Brand,
      label: 'Brand',
      onClick: () => setTab(Tabs.Brand),
      disabled: !isAdmin,
    },
  ];

  const RenderTabs = () => {
    return (
      <Div $flex $gap="16px" $m="32px 0" $mSM="20px 0">
        {actions.map((action) => {
          if (action.disabled) {
            return null;
          }
          return (
            <Tab
              $width="170px"
              $widthSM="calc(33.3% - 12px)"
              $minWidthAutoSM
              selected={tab === action.value}
              key={action.value}
              onClick={action.onClick}
            >
              {action.label}
            </Tab>
          );
        })}
      </Div>
    );
  };

  return (
    <>
      <AdminHeader title={`Settings`}>
        <Div $desktop>
          <RenderTabs />
        </Div>
      </AdminHeader>
      <Div $mobile>
        <RenderTabs />
      </Div>

      {tab === Tabs.General && <GeneralSettings />}
      {tab === Tabs.Location && <LocationSettings />}
      {isAdmin && tab === Tabs.Brand && <BrandSettings />}
    </>
  );
};
